import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../shared/api.service';
import { saveAs } from 'file-saver';
import { Common } from '../../shared/common';
import { ReceivedPoll } from '../../models/ReceivedPoll';
import { ParticipationResponse } from '../../models/ParticipationResponse';
import {ShortVoter} from '../../models/ShortVoter';
import {AssessorData} from '../../models/AssessorData';


@Component({
  selector: 'app-poll-audit-status',
  templateUrl: 'poll-audit-status.component.html',
  styleUrls: ['./poll-audit-status.component.less', './../../shared/common.less']
})

export class PollAuditStatusComponent implements OnInit {
  @Input() status: boolean;
  @Input() assessors: number;
  @Input() inactiveAssessors: number;

  constructor(private router: Router,
              private apiService: ApiService,
              private route: ActivatedRoute,
              public common: Common
              ) { }

  initData() {
    
  }

  ngOnInit() {
    
  }
}
